import { createAsyncThunk } from '@reduxjs/toolkit';
import { ChangeUserProfileStatus } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreateChangeUserProfileStatus
} from './interface';

export const createChangeUserProfileStatus = createAsyncThunk(
  'changeUserProfileStatus/createChangeUserProfileStatus',
  async (values: CreateChangeUserProfileStatus, { rejectWithValue }) => {
    try {
      const response = await ChangeUserProfileStatus.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);